import { actionCreators } from '../../store/actions';
import ReduxActions from '../../store/ReduxActions';
import BackendApiClient from './BackendApiClient';
import { DataWrappedResponse } from '../exports/Types';
import { CashbackAccount, ProfileInterface, RewardAccount } from '../exports/Interfaces';

class ProfileManager {
  public getProfile = async (companyId: number): Promise<DataWrappedResponse<ProfileInterface>> => {
    const request = await BackendApiClient.request({
      method: 'GET',
      url: `/companies/${companyId}/profile`,
    });
    const { response, success } = request;

    if (success) {
      ReduxActions.dispatch(this.profileAction(response?.data?.data));
    }

    return request;
  };

  public putProfile = async (
    companyId: number,
    data: ProfileInterface,
  ): Promise<DataWrappedResponse<ProfileInterface>> => {
    const request = await BackendApiClient.request({
      method: 'PUT',
      url: `/companies/${companyId}/profile`,
      data,
    });
    const { response, success } = request;

    if (success) {
      ReduxActions.batchActions([this.profileAction(response.data.data), this.orderAction(response.data.data)]);
    }

    return request;
  };

  public getCashbackAccount = async (companyId: number): Promise<DataWrappedResponse<CashbackAccount>> => {
    const request = await BackendApiClient.request({
      method: 'GET',
      url: `/companies/${companyId}/cashback-account`,
    });
    const { response, success } = request;

    if (success) {
      ReduxActions.dispatch(actionCreators.initialData.setCashbackAccount(response.data.data));
    }

    return request;
  };

  public getRewardAccount = async (companyId: number): Promise<DataWrappedResponse<RewardAccount>> => {
    const request = await BackendApiClient.request({
      method: 'GET',
      url: `/companies/${companyId}/reward-account`,
    });
    const { response, success } = request;

    if (success) {
      ReduxActions.dispatch(actionCreators.initialData.setRewardAccount(response.data.data));
    }

    return request;
  };

  private profileAction(data: ProfileInterface) {
    return actionCreators.profile.setProfile(data);
  }

  private orderAction(data: ProfileInterface) {
    return actionCreators.order.updateOrder({
      customer_phone_number: data.phone_number,
      customer_email: data.email,
      customer_first_name: data.first_name,
      customer_last_name: data.last_name,
      delivery_doorbell_name: data.delivery_doorbell_name,
      delivery_company_name: data.delivery_company_name,
      customer_note: data.customer_note,
      delivery_street_name: data.delivery_street_name,
      delivery_street_number: data.delivery_street_number,
      delivery_city: data.delivery_city,
      delivery_state: data.delivery_state,
      delivery_country: data.delivery_country,
      delivery_zip_code: data.delivery_zip_code,
      delivery_lat: data.delivery_lat,
      delivery_lng: data.delivery_lng,
    });
  }
}

export default new ProfileManager();
